export interface AnalyticsScope {
  userId: string;
  organizationId: string | null;
}

export function analyticsKey(
  scope: AnalyticsScope,
  family: string,
  ...parts: unknown[]
) {
  return [
    "analytics",
    scope.userId,
    scope.organizationId,
    family,
    ...parts,
  ] as const;
}
